import { cpf } from 'cpf-cnpj-validator'
import { isValidCPF } from 'src/utils'
import * as yup from 'yup'

export const changePasswordSchema = yup.object().shape({
  username: yup.string().required('Campo obrigatório.'),
  adminUsername: yup.string().required('Campo obrigatório.'),
  senha: yup
    .string()
    .required('Senha é obrigatória')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      'A senha deve ter no mínimo 8 caracteres com maiúscula, minúscula e número'
    ),
  confirmSenha: yup
    .string()
    .oneOf([yup.ref('senha')], 'As senhas não são iguais.')
    .required('Confirmação de senha é obrigatória')
})

export const userProfileSchema = yup.object().shape({
  nome: yup.string().required('Nome é obrigatório').matches(/^\S+$/, 'O nome não pode conter espaços'),
  sobrenome: yup.string().nullable(),
  documento: yup
    .string()
    .nullable()
    .test('cpf-valido', 'CPF inválido', (value) => {
      if (!value) return true
      return isValidCPF(value || '')
    }),
  telefone: yup.string().nullable()
})

export const registerSchema = yup.object({
  nome: yup.string().required('Nome é obrigatório').matches(/^\S+$/, 'O nome não pode conter espaços'),
  sobrenome: yup.string().required('Sobrenome é obrigatório'),
  email: yup
    .string()
    .transform((value) => value?.replace(/\s/g, ''))
    .required('E-mail é obrigatório')
    .email('E-mail inválido')
    .matches(/^\S+$/, 'E-mail não pode conter espaços'),
  documento: yup
    .string()
    .nullable()
    .notRequired()
    .test('cpf-valido', 'CPF inválido', (value) => {
      if (!value) return true

      return cpf.isValid(value)
    }),
  telefone: yup.string().required('Telefone é obrigatório'),
  fazenda: yup.string().required('Nome da Fazenda é obrigatório'),
  senha: yup
    .string()
    .required('Senha é obrigatória')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      'A senha deve ter no mínimo 8 caracteres com maiúscula, minúscula e número'
    )
})

export const resetPasswordSchema = yup.object({
  email: yup
    .string()
    .transform((value) => value?.replace(/\s/g, ''))
    .required('E-mail é obrigatório')
    .email('E-mail inválido')
    .matches(/^\S+$/, 'E-mail não pode conter espaços')
})

export * from './User'
